import "bootstrap/dist/css/bootstrap.css";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";

import store from "./store";
import App from "./App";

import "./localization/i18n";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

// No OIDC config, no window.userManager
// Authentication is handled via ASP.NET Identity cookie

ReactDOM.render(
    <Provider store={store}>
        <Router basename={baseUrl}>
            <React.Suspense fallback="Loading ...">
                <App />
            </React.Suspense>
        </Router>
    </Provider>,
    rootElement
);